__turbopack_context__.v({
  "cardImage": "MdJY7a_cardImage",
  "cardItem": "MdJY7a_cardItem",
  "cardLogo": "MdJY7a_cardLogo",
  "frame": "MdJY7a_frame",
  "scroll": "MdJY7a_scroll",
  "track": "MdJY7a_track",
});
